module.exports = __webpack_public_path__ + "static/media/t_icon_03.e7a25c6f.png";